module.exports = __webpack_public_path__ + "media/images/pic/hero/news-e9fde5abd7978b3399946204ce0c3fc4.webp";